import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { VideoListDetail } from '@src/components/sco/Education/VideoListDetail';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React, { useEffect } from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const routerParams = useParams();
  const educationContext = useEducationContext();
  useEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
      // isDrawerOpen: false,
    });
    educationContext.setActiveSection('videos.series');
  }, []);
  return <VideoListDetail videoListSlug={`${routerParams?.videoListSlug}`} />;
});